export default {
    // 中
    zhCN: {
        department_name: '部门名称',
        encoded: '编码',
        name: '名称',
        disable_time: '禁用时间',
        disabled_person: '禁用人',
    },
    // 英
    enUS: {
        department_name: 'Department name',
        encoded: 'Encoded',
        name: 'Name',
        disable_time: 'Disable time',
        disabled_person: 'Disabled person',
    },
    // 德
    deDE: {
        department_name: 'Abteilungsname',
        encoded: 'Codiert',
        name: 'Name',
        disable_time: 'Deaktivierungszeit',
        disabled_person: 'Deaktivierte Person',
    },
    // 法
    frFR: {
        department_name: 'Nom du département',
        encoded: 'Encodé',
        name: 'Nom',
        disable_time: 'Heure de désactivation',
        disabled_person: 'Personne désactivée',
    },
    // 意大利
    itIT: {
        department_name: 'Nome Dipartimento',
        encoded: 'Codifica',
        name: 'Nome',
        disable_time: 'Tempo Disabilitazione',
        disabled_person: 'Persona Disabilitata',
    },
    // 荷兰
    nlNL: {
        department_name: 'Afdelingsnaam',
        encoded: 'Gecodeerd',
        name: 'Naam',
        disable_time: 'Uitschakeltijd',
        disabled_person: 'Gehandicapte persoon',
    },
    // 越南
    viVN: {
        department_name: 'Tên phòng ban',
        encoded: 'Mã hóa',
        name: 'Tên',
        disable_time: 'Thời gian vô hiệu hóa',
        disabled_person: 'Người vô hiệu hóa',
    },
    // 西班牙
    esES: {
        department_name: 'Nombre del departamento',
        encoded: 'Código',
        name: 'Nombre',
        disable_time: 'Tiempo de desactivación',
        disabled_person: 'Persona que desactivó',
    },
    // 葡萄牙
    ptBR: {
        department_name: 'Nome do departamento',
        encoded: 'Codificado',
        name: 'Nome',
        disable_time: 'Tempo desabilitado',
        disabled_person: 'Pessoa desabilitada',
    },
    // 波兰
    plPL: {
        department_name: 'Nazwa oddziału',
        encoded: 'Kod',
        name: 'Nazwa',
        disable_time: 'Czas blokady',
        disabled_person: 'Osoba zablokowana',
    },
    // 土耳其
    trTR: {
        department_name: 'Departman adı',
        encoded: 'Kodlanmış',
        name: 'İsim',
        disable_time: 'Devre dışı bırakma zamanı',
        disabled_person: 'Engelleyen kişi',
    },
    // 捷克语
    csCZ: {
        department_name: 'Název oddělení',
        encoded: 'Kódované',
        name: 'název',
        disable_time: 'Čas vypnutí',
        disabled_person: 'Postižený člověk',
    },
    // 匈牙利语
    huHU: {
        department_name: 'Részleg neve',
        encoded: 'Kódolva',
        name: 'Név',
        disable_time: 'Kikapcsolás ideje',
        disabled_person: 'Mozgássérült személy',
    },
    // 俄罗斯语
    ruRU: {
        department_name: 'Название отдела',
        encoded: 'Код',
        name: 'Имя',
        disable_time: 'Время отключения',
        disabled_person: 'Отключивший',
    },
    // 沙特阿拉伯
    arSA: {
        department_name: 'اسم القسم',
        encoded: 'الترميز',
        name: 'الاسم',
        disable_time: 'وقت التعطيل',
        disabled_person: 'المعطل بواسطة',
    },
    // 保加利亚
    bgBG: {
        department_name: 'Име на отдел',
        encoded: 'Код',
        name: 'Име',
        disable_time: 'Време на деактивиране',
        disabled_person: 'Деактивиран от',
    },
    // 丹麦语
    daDK: {
        department_name: 'Afdelingsnavn',
        encoded: 'Kode',
        name: 'Navn',
        disable_time: 'Deaktiveret tidspunkt',
        disabled_person: 'Deaktiveret af',
    },
    // 芬兰语
    fiFI: {
        department_name: 'Osaston nimi',
        encoded: 'Koodi',
        name: 'Nimi',
        disable_time: 'Poistettu käytöstä',
        disabled_person: 'Poistanut käytöstä',
    },
    // 繁体中文台湾
    zhTW: {
        department_name: '部門名稱',
        encoded: '編碼',
        name: '名稱',
        disable_time: '停用時間',
        disabled_person: '停用人',
    },
    // 克罗地亚
    hrHR: {
        department_name: 'Naziv odjela',
        encoded: 'Kôd',
        name: 'Naziv',
        disable_time: 'Vrijeme onemogućavanja',
        disabled_person: 'Onemogućio/la',
    },
    // 拉脱维亚
    lvLV: {
        department_name: 'Departamenta nosaukums',
        encoded: 'Kods',
        name: 'Nosaukums',
        disable_time: 'Atspējošanas laiks',
        disabled_person: 'Atspējoja',
    },
    // 立陶宛
    ltLT: {
        department_name: 'Skyriaus pavadinimas',
        encoded: 'Kodas',
        name: 'Pavadinimas',
        disable_time: 'Išjungimo laikas',
        disabled_person: 'Išjungė',
    },
    // 罗马尼亚
    roRO: {
        department_name: 'Nume departament',
        encoded: 'Cod',
        name: 'Nume',
        disable_time: 'Timp dezactivare',
        disabled_person: 'Dezactivat de',
    },
    // 挪威博克马尔
    nbNO: {
        department_name: 'Avdelingsnavn',
        encoded: 'Kode',
        name: 'Navn',
        disable_time: 'Deaktivert tidspunkt',
        disabled_person: 'Deaktivert av',
    },
    // 葡萄牙语巴西
    ptBX: {
        department_name: 'Nome do Departamento',
        encoded: 'Código',
        name: 'Nome',
        disable_time: 'Horário de desativação',
        disabled_person: 'Desativado por',
    },
    // 瑞典语
    svSE: {
        department_name: 'Avdelningsnamn',
        encoded: 'Kod',
        name: 'Namn',
        disable_time: 'Inaktiveringstid',
        disabled_person: 'Inaktiverad av',
    },
    // 斯洛伐克
    skSK: {
        department_name: 'Názov oddelenia',
        encoded: 'Kód',
        name: 'Názov',
        disable_time: 'Čas deaktivácie',
        disabled_person: 'Deaktivoval/a',
    },
    // 斯洛文尼亚
    slSI: {
        department_name: 'Ime oddelka',
        encoded: 'Koda',
        name: 'Ime',
        disable_time: 'Čas onemogočenja',
        disabled_person: 'Onemogočil/a',
    },
    // 泰语
    thTH: {
        department_name: 'ชื่อแผนก',
        encoded: 'รหัส',
        name: 'ชื่อ',
        disable_time: 'เวลาปิดการใช้งาน',
        disabled_person: 'ผู้ปิดการใช้งาน',
    },
    // 乌克兰语
    ukUA: {
        department_name: 'Назва відділу',
        encoded: 'Код',
        name: 'Назва',
        disable_time: 'Час деактивації',
        disabled_person: 'Деактивовано користувачем',
    },
    // 希腊语
    elGR: {
        department_name: 'Όνομα Τμήματος',
        encoded: 'Κωδικός',
        name: 'Όνομα',
        disable_time: 'Ώρα απενεργοποίησης',
        disabled_person: 'Απενεργοποιήθηκε από',
    },
    // 爱沙尼亚
    etEE: {
        department_name: 'Osakonna nimi',
        encoded: 'Kood',
        name: 'Nimi',
        disable_time: 'Keelamise aeg',
        disabled_person: 'Keelas',
    },
    // 哈萨克
    kkKZ: {
        department_name: 'Бөлім атауы',
        encoded: 'Код',
        name: 'Атауы',
        disable_time: 'Сөндіру уақыты',
        disabled_person: 'Сөндірген адам',
    },
    // 希伯来语
    heIL: {
        department_name: 'שם המחלקה',
        encoded: 'קידוד',
        name: 'שם',
        disable_time: 'זמן השבתה',
        disabled_person: 'הושבת על ידי',
    },
};
